import { render, staticRenderFns } from "./commonSearchStaff.vue?vue&type=template&id=73467f0c&scoped=true"
import script from "./commonSearchStaff.vue?vue&type=script&lang=js"
export * from "./commonSearchStaff.vue?vue&type=script&lang=js"
import style0 from "./commonSearchStaff.vue?vue&type=style&index=0&id=73467f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73467f0c",
  null
  
)

export default component.exports